import TableFooter from "@material-ui/core/TableFooter";
export default TableFooter;